// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';

export const RefineChange = zod.object({
  "add": zod.array(zod.string()),
  "audience": zod.enum(['internal', 'shareable']),
  "current": zod.union([zod.string(),zod.null()]),
  "id": zod.string(),
  "key": zod.string(),
  "proposed": zod.string(),
  "remove": zod.array(zod.string()),
  "sources": zod.union([zod.array(ProposalSource),zod.literal("instruction")]),
  "target": zod.enum(['field', 'section']),
  "title": zod.string()
});

export type RefineChange = zod.input<typeof RefineChange>;
export type RefineChangeOutput = zod.output<typeof RefineChange>;
